


import { Injectable, signal } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class JobSeekerService {
  selectedId = signal<string | null>(null);
  column = signal<number | null>(3);

  setId(id: string): void {
    this.selectedId.set(id);
  }

  getId(): string | null {
    return this.selectedId();
  }

  setColumnId(id: number): void {
    console.log('Setting column:', id);

    this.column.set(id);
  }

  getColumnId(): number | null {
    console.log('gettinng column:');

    return this.column();
  }

  fullScreenDisplay = signal(false); // default visible

  setFullScreenDisplay(value: boolean) {
    this.fullScreenDisplay.set(value);
  }

  constructor(private http: HttpClient, private api: ApiService) { }

  validateUser(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.validateUser, data);
  }
  updateProfile(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.updateProfile, data,);
  }
  getUserQualification(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getUserQualification, data,);
  }
  addEducation(data: any) {

    return this.api.POST_BR(environment.JOB_SEEKER_APIS.addEducation, data,);
  }
  createCandidateAddress(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createCandidateAddress, data,);
  }
  updateCandidateAddress(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.updateCandidateAddress, data,);
  }
  getUserLangauges(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getUserLangauges, data,);
  }
  getResumePathsById(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getResumePathsById + "?uuid=" + uuid, data,);
  }
  getAllJobType(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllJobType, data,);
  }
  getUserIndustries(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getUserIndustries, data,);
  }
  createOrUpdateResume(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createOrUpdateResume, data,);
  }

  previewCV(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.previewCV, data,);
  }

  getDashboardDetails(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getDashboardDetails + "?uuid=" + uuid, data);
  }

  createResumePath(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createResumePath, data,);
  }
  createCandidateCertification(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createCandidateCertification, data,);
  }

  deleteResumesPath(data: any) {
    let uuid = data.uuid,
      user_id = data.user_id,
      id = data.id;
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.deleteResumesPath + "?uuid=" + uuid
      + "&user_id=" + user_id + "&id=" + id, data);
  }
  createCandidatePreferredLocations(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createCandidatePreferredLocations, data);
  }

  addExperience(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.addExperience, data);
  }

  uploadAvatar(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.uploadAvatar, data,);

  }

  getAllResumeBuilderPlans(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllResumeBuilderPlans, data,);

  }

  initiateOrderResumeBuilder(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.initiateOrderResumeBuilder, data,);
  }
  createPurchaseOrderResumeBuilder(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createPurchaseOrderResumeBuilder, data,);
  }

  getAllTransactionOrdersResumeBuilder(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllTransactionOrdersResumeBuilder + "?uuid=" + uuid, data,);
  }

  generateCV(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.generateCV, data);
  }
  getResumePlansPurchased(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getResumePlansPurchased, data);
  }

  getJobSeekerDashboard(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getJobSeekerDashboard, data);
  }

  getSelfCoverLetter(data: any) {
    return this.api.POST_BR(environment.AI_APIS.getSelfCoverLetter, data);
  }

  createCandidateWorkLinks(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createCandidateWorkLinks, data);
  }
  updateCandidateWorkLinks(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.updateCandidateWorkLinks, data);
  }
  createVisaDetails(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createVisaDetails, data);
  }
  updateVisaDetails(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.updateVisaDetails, data);
  }

  getVisaTypeMaster(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getVisaTypeMaster, data);
  }

  userRegistration(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.userRegistration, data);
  }
  generateUserMobileOTP(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.generateUserMobileOTP, data,);
  }
  validateUserMobileOtp(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.validateUserMobileOtp, data);
  }
  forgotPassword(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.forgotPassword, data,);
  }

  companyUnfollowStatus(data: any) {

    return this.api.POST_BR(environment.JOB_SEEKER_APIS.companyUnfollowStatus, data);
  }

  companyFollowStatus(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.companyFollowStatus, data);
  }

  getFollowedCompanies(data: any) {
    let user_uuid = data.user_uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getFollowedCompanies + "?user_uuid=" + user_uuid, data);
  }

  getSchedulesByUserId(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getSchedulesByUserId + "?uuid=" + uuid, data);
  }

  jobSaved(data: any) {
    let uuid = data.uuid,
      job_id = data.job_id
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.jobSaved + "?uuid=" + uuid
      + "&job_id=" + job_id, data,);
  }
  getAllSavedJobs(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllSavedJobs + "?uuid=" + uuid, data,);
  }
  getAppliedJobs(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAppliedJobs + "?uuid=" + uuid, data,);
  }
  createJobApplied(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.createJobApplied, data,);
  }
  getEmailsByuserId(data: any) {
    let to_uuid = data.to_uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getEmailsByuserId + "?to_uuid=" + to_uuid, data,);
  }

  getAllCountries(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllCountries, data,);
  }
  userFilterJobPosting(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.userFilterJobPosting, data,);
  }
  getAllCollections(data: any) {
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getAllCollections, data,);
  }
  getUserQNAs(data: any) {
    let job_ref_id = data.job_ref_id;
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getUserQNAs + "?job_ref_id=" + job_ref_id, data,);
  }
  generateMobileOTP(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.generateMobileOTP + "?uuid=" + uuid, data,);
  }

  generateEmailOTP(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.generateEmailOTP, data,);
  }
  validateEmailOtp(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.validateEmailOtp, data,);
  }
  candidateResumePublish(data: any) {
    return this.api.POST_BR(environment.JOB_SEEKER_APIS.candidateResumePublish, data,);
  }
  getStatesByCountryCode(data: any) {
    let country_code = data.country_code
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getStatesByCountryCode + "?country_code=" + country_code, data);
  }
  getCitiesByStateId(data: any) {
    let state_id = data.state_id
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.getCitiesByStateId + "?state_id=" + state_id, data);
  }

  jobAppliedStatus(data: any) {
    let job_id = data.job_id, uuid = data.uuid
    return this.api.GET_BR(environment.JOB_SEEKER_APIS.jobAppliedStatus + "?job_id=" + job_id + "&uuid=" + uuid, data);
  }
}
